import { defineMessages } from 'react-intl'

export default defineMessages({
  create: {
    defaultMessage: 'Assessment erstellen',
  },
})
